import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';

const PaymentProcessor = ({ open, onClose, plan, isAnnual }) => {
    const { user } = useAuth();
    const navigate = useNavigate();

    // Map your plans to PayPal plan IDs
    const PLAN_IDS = {
        pro: {
            monthly: process.env.REACT_APP_PRO_MONTHLY,
            annual: process.env.REACT_APP_PRO_YEARLY
        },
        master: {
            monthly: process.env.REACT_APP_MASTER_MONTHLY,
            annual: process.env.REACT_APP_MASTER_YEARLY
        }
    };

    // Helper function to get email limit based on plan
    const getEmailLimit = (planType) => {
        switch (planType.toLowerCase()) {
            case 'pro':
                return 20;
            case 'master':
                return 40;
            default:
                return 5;
        }
    };

    // Function to update user subscription in Firebase
    const updateUserSubscription = async (subscriptionID, selectedPlan) => {
        if (!user?.email) return;

        try {
            const userRef = doc(db, 'users', user.email);
            await updateDoc(userRef, {
                subscription_plan: selectedPlan.toLowerCase(),
                emailsRemaining: getEmailLimit(selectedPlan),
                paypal_subscription_id: subscriptionID,
                subscription_updated_at: new Date().toISOString()
            });

            // Navigate to success page
            navigate('/payment-success');
        } catch (error) {
            console.error('Error updating subscription:', error);
            // You might want to handle this error more gracefully
            navigate('/payment-cancelled');
        }
    };

    useEffect(() => {
        if (open) {
            // Load PayPal script when dialog opens
            const script = document.createElement('script');
            script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&vault=true&intent=subscription`;
            script.addEventListener('load', initializePayPalButton);
            document.body.appendChild(script);

            return () => {
                // Cleanup
                document.body.removeChild(script);
                const buttonContainer = document.getElementById('paypal-button-container');
                if (buttonContainer) {
                    buttonContainer.innerHTML = '';
                }
            };
        }
    }, [open]);

    const initializePayPalButton = () => {
        if (!plan) return;

        const planId = PLAN_IDS[plan.toLowerCase()][isAnnual ? 'annual' : 'monthly'];
        console.log("Plan id:", planId);

        window.paypal.Buttons({
            createSubscription: (data, actions) => {
                return actions.subscription.create({
                    'plan_id': planId
                });
            },
            onApprove: async (data, actions) => {
                // Handle successful subscription
                console.log('Subscription successful:', data.subscriptionID);

                // Update Firebase with new subscription info
                await updateUserSubscription(data.subscriptionID, plan);

                onClose();
            },
            onError: (err) => {
                console.error('PayPal Error:', err);
                onClose();
                navigate('/payment-cancelled');
            }
        }).render('#paypal-button-container');
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Complete Your Subscription</DialogTitle>
            <DialogContent>
                <Box sx={{
                    width: '300px',
                    minHeight: '150px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div id="paypal-button-container"></div>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default PaymentProcessor;